<template>
  <v-container fluid class="admin-purchase-order">
    <v-row class="flex-grow-0">
      <v-col class="text-right">
        <v-btn color="primary"
               class="ml-2"
               @click="exportItems">
          {{ $t('export') }}
        </v-btn>
        <v-btn color="primary"
               class="ml-2"
               @click="create">
          {{ $t('admin_acc_purchase_order.add_title') }}
        </v-btn>
      </v-col>
    </v-row>
    <AdminPurchaseOrderList full-height
                            @filter="onFilterChange"
                            :refresh-trigger.sync="bookingRefreshTrigger"></AdminPurchaseOrderList>
  </v-container>
</template>
<script>
import {ref} from "@vue/composition-api";
import AdminPurchaseOrderList from "@/components/acc_booking/purchase_order/AdminPurchaseOrderList.vue";
import AddPurchaseOrderModal from "@/components/acc_booking/purchase_order/AddPurchaseOrderModal.vue";

export default {
  name: 'PurchaseOrder',
  components: {AdminPurchaseOrderList},
  setup(props, {root}) {
    const bookingRefreshTrigger = ref(false);
    const refresh = function () {
      bookingRefreshTrigger.value = !bookingRefreshTrigger.value;
    };

    const exportItems = function () {
      root.$downloadFile("aafb/admin/purchase_order/export/", {
        filters: currentFilters.value,
      }, 'purchase_orders.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    }

    const create = async function () {
      const needRefresh = await root.$dialog.showAndWait(AddPurchaseOrderModal, {
        showClose: false,
        persistent: true,
        width: '80vw',
      });

      if (needRefresh) {
        refresh();
      }
    }

    const currentFilters = ref(null);
    const onFilterChange = function (filters) {
      currentFilters.value = filters;
    }

    return {
      bookingRefreshTrigger,
      refresh,

      exportItems,
      create,
      onFilterChange,
    }
  }
}
</script>

<style lang="less">
.admin-purchase-order {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>

